export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8208.e675176d.jpg";